import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex'
  },
  search: {
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 450
    },

    '& fieldset': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.primary.contrastText
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    }
  },
  button: {
    zIndex: 1
  },
  helperText: {
    marginTop: theme.spacing(2),
    fontSize: '.875rem',
    fontWeight: 500,
    color: theme.palette.primary.main
  },
  selectContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    marginTop: theme.spacing(2),
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    }
  },
  select: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    backgroundColor: '#000051',
    padding: 0,
    '& fieldset': {
      borderColor: '#000051'
    },

    '& svg': {
      color: theme.palette.secondary.main
    },
    [theme.breakpoints.up('lg')]: {
      width: '32%'
    }
  },
  table: {
    marginTop: theme.spacing(2),
    width: '100%',
    borderCollapse: 'collapse',
    borderSpacing: 0,
    color: theme.palette.primary.main,
    '& th': {
      textAlign: 'left',
      fontSize: '0.7rem',
      padding: theme.spacing(0.75)
    },
    '& td': {
      textAlign: 'left',
      padding: theme.spacing(0.5),
      fontSize: '.75rem',
      borderBottom: '1px solid #E6E6E6',
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(0.75),
        fontSize: '.875rem'
      }
    },
    '& tr:nth-child(even)': {
      backgroundColor: '#D9D9D95E'
    },
    '& table': {
      width: '100%'
    },

    '& table th': {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  col: {
    paddingLeft: `${theme.spacing(3)}px !important`
  },
  largueCol: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'table-cell'
    }
  },

  expandButton: {
    padding: 0
  },
  runnerImage: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      borderRadius: 75,
      width: 25,
      height: 25,
      marginLeft: -theme.spacing(3),
      flexShrink: 0
    }
  },
  linkUser: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  },
  row: {
    transition: 'all .3s',

    '&.expanded': {
      backgroundColor: '#000051 !important',
      color: theme.palette.primary.contrastText,
      '& a, p': {
        color: theme.palette.primary.contrastText
      }
    }
  },
  innerTableCell: {
    backgroundColor: theme.palette.primary.contrastText,
    padding: 0,
    '& td': {
      borderBottom: 'none'
    }
  },
  eventLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}))
